import { TableCell, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StatisticsVariant } from '../../types/statistic-variant';

const monthMap = {
  '01': 'jan',
  '02': 'feb',
  '03': 'mar',
  '04': 'apr',
  '05': 'may',
  '06': 'jun',
  '07': 'jul',
  '08': 'aug',
  '09': 'sep',
  '10': 'oct',
  '11': 'nov',
  '12': 'dec',
};

type Props = {
  date: string;
  bookingsCount: number;
  variant: StatisticsVariant;
};

export default function TypeSpecificStatisticsTableRow({
  date,
  bookingsCount,
  variant,
}: Props) {
  //add date translations?
  const { t } = useTranslation();
  const [year, month, day] = date.split('-');

  return (
    <TableRow>
      <TableCell>
        <Typography variant="body2">
          {variant === 'MONTHLY'
            ? t(
                `common:calendar.months.${monthMap[month as keyof typeof monthMap]}`,
              ) + ` ${year}`
            : `${day}.${month}.${year}`}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{bookingsCount}</Typography>
      </TableCell>
    </TableRow>
  );
}
